import { config } from "@nova/configuration/browser"
import { infraredFlight, orthoFlight, pdf, TransferSettings, transferSettings } from "@nova/schemas"
import { useMemo } from "react"

export const useTransferSettings = () => {
    const { transferIntegration } = config.use("transferIntegration")
    const transferIntegrationSettings = useMemo(() => {
        if (!transferIntegration) return
        try {
            const settings = JSON.parse(transferIntegration)
            console.log(settings)
            return transferSettings.parse(settings)
        } catch (err) {
            console.error(err)
            return
        }
    }, [transferIntegration])
    return transferIntegrationSettings
}

export const createTransferableFromOptions = (
    type: "ir" | "rgb" | "pdf",
    id: string,
    settings: TransferSettings
) => {
    let include = {} as Record<string, boolean>
    switch (type) {
        case "ir":
            include = {
                hotspotPoints: true,
                perimeter: true,
                flightPath: true,
                images: true,
                ortho: true,
            }
            Object.entries(settings.options?.infrared || {}).forEach(([key, value]) => {
                if (include[key] !== value) include[key] = value
            })
            return infraredFlight.encode({
                type: "infraredFlight",
                id,
                include,
            })
        case "rgb":
            include = {
                flightPath: true,
                images: true,
                ortho: true,
            }
            Object.entries(settings.options?.ortho || {}).forEach(([key, value]) => {
                if (include[key] !== value) include[key] = value
            })
            return orthoFlight.encode({
                type: "orthoFlight",
                id,
                include,
            })
        case "pdf":
            return pdf.encode({
                type: "pdf",
                id,
            })
        default:
            const _type: never = type // check all cases are covered
            throw new Error("Unrecognized type")
    }
}
